<template>
    <main
    class="main animated fadeIn faster"
    :class="{ 'expand-main': isMenuCollapse }"
    >
    <h3>Booker Dashboard</h3>
    <div v-if="loading">

    </div>
    <div v-else>

    </div>
    </main>
</template>
<script>
import { bookersService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import { mapState, mapActions } from "vuex";

export default{
    components: {
      LoadingSpinner,
      },
      computed: {
        ...mapState({
            isMenuCollapse: (state) => state.sidebar.isNavOpen,
        }),
        user() {
            return this.$store.state.authentication.user;
        },
      },
      data(){
          return{
            loading: false,
          };
      },
      created(){
        this.getData();
      },
      mounted(){
        this.setHeader();
      },
      methods:{
        ...mapActions("headertopbar", {
            setCurrentRoute:"setRoute",
            setCurrentRouteChild:"setRouteChild"
        }),
        setHeader() {
            this.setCurrentRoute({ page: "booker-dashboard", label: "Booker Dashboard" });
            this.setCurrentRouteChild({ child: "" });
        },
        getData(){
            console.log(this.user);
        },
      },
}
</script>
<style>

</style>